define('viewmodels/pages/about',['underscore', 'knockout'], function (_, ko) {

    var AboutContentBlock = function(block) {
        // jshint sub: true
        return {
            headerText: block['header_text'],
            headerUrl: block['header_url'],
            image: block.image,
            text: block.text,
            cssClass: _.compact([block['header_text_color'], block['header_background_color']]).join(' ')
        };
    };

    return function AboutViewModel(aboutPageField) {
        var self = this;

        self.blocks = ko.pureComputed(function() {
            var blocks = aboutPageField('blocks')();
            if (!_.some(blocks)) {
                return [];
            }

            return _.map(blocks, AboutContentBlock);
        });
    };

});

